import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import React from 'react';
import { useTranslation } from 'react-i18next';
function BfgScoreFormula() {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 3
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontSize: 18,
      fontWeight: 800
    }
  }, t('commons.challenges.bfg_faq.score_formula.title')), /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, t('commons.challenges.bfg_faq.score_formula.description'))), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    borderRadius: 2,
    display: "flex",
    flexDirection: {
      xs: 'column',
      sm: 'row'
    },
    gap: 2,
    padding: 3,
    sx: {
      background: '#ECFBF4',
      border: '1px solid #CDF5E3'
    }
  }, /*#__PURE__*/React.createElement(FormulaBlock, {
    label: t('commons.challenges.bfg_faq.score_formula.points_label'),
    title: t('commons.challenges.bfg_faq.score_formula.points_title')
  }), /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontSize: 32,
      fontWeight: 700
    }
  }, "\xD7"), /*#__PURE__*/React.createElement(FormulaBlock, {
    label: t('commons.challenges.bfg_faq.score_formula.rate_label'),
    title: t('commons.challenges.bfg_faq.score_formula.rate_title')
  }), /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontSize: 32,
      fontWeight: 700
    }
  }, "="), /*#__PURE__*/React.createElement(FormulaBlock, {
    label: t('commons.challenges.bfg_faq.score_formula.score_label'),
    title: t('commons.challenges.bfg_faq.score_formula.score_title')
  })), /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    variant: "body2"
  }, /*#__PURE__*/React.createElement("em", null, t('commons.challenges.bfg_faq.score_formula.example'))));
}
function FormulaBlock({
  title,
  label
}) {
  return /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 0.5,
    minWidth: 0,
    padding: 2,
    width: {
      xs: '100%',
      sm: 'auto'
    }
  }, /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      color: '#048760',
      fontSize: 24,
      fontWeight: 800,
      textAlign: 'center'
    }
  }, title), /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      color: 'text.secondary',
      fontSize: 14,
      fontWeight: 400,
      lineHeight: 1.5,
      textAlign: 'center'
    }
  }, label));
}
export default BfgScoreFormula;